export default "__VITE_ASSET__DzFGv5IT__"